// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#customToolbar > :not(:last-child) {\n  margin-right: 0.25rem;\n}\n#customToolbar > :not(:first-child) {\n  margin-left: 0.25rem;\n}\n", ""]);
// Exports
module.exports = exports;
